import { NotificationBase } from 'src/app/shared/services/notification/notification-base';
import { NotificationFlexAvailabilityModal } from '../../../pages/flex/components/notification-flex-availability/notification-flex-availability.component';

export class NotificationFlexAvailability extends NotificationBase {
  async process(): Promise<void> {
    if (this.item) {
      const modal = await this.modalCtrl.create({
        component: NotificationFlexAvailabilityModal,
      });

      // https://github.com/ionic-team/ionic-framework/issues/26872
      modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

      modal.present();
    }
  }

  protected viewNotification(): void {}
}
